export default __webpack_public_path__ + "static/high-complexity-577c6e43fc7afd8c66c067c5526572939c4696d238a981b8dace36f15b36392d.png";